import { Alert, Button, Popconfirm, Space } from "antd"
import { useNavigate } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import { getCodes } from "../../store/slices/codeSlice";
import { deleteRole, getRoles } from "../../store/slices/roleSlice";
import { CheckCircleOutlined, CloseCircleOutlined, DeleteFilled, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useDispatch } from "react-redux";
import Can from "../../permission/Can";

const RoleList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [reload, setReload] = useState(false)
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = (truckId) => {
        setOpen(truckId);
    };
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Can permission="edit_role">
                        <Button onClick={() => navigate('/role/edit/' + data?._id)} icon={<EyeOutlined />} size="small">Edit</Button>
                    </Can>
                    {/* <Button icon={<DeleteOutlined />} size="small" danger>Delete</Button> */}
                    <Can permission="delete_role">
                        <Popconfirm
                            title="Delete confirmation"
                            description="Do you want to delete this?"
                            open={open == data?._id}
                            icon={<DeleteFilled />}
                            onConfirm={() => handleDeleteRole(data?._id)}
                            okButtonProps={{ loading: confirmLoading }}
                            onCancel={handleCancel}
                        >
                            <Button icon={<DeleteOutlined />} onClick={() => showPopconfirm(data?._id)} size="small" danger>Delete</Button>
                        </Popconfirm>
                    </Can>
                </Space>
            ),
        }
    ];

    const handleCancel = () => {
        setOpen(false);
    };

    const handleDeleteRole = async (id) => {
        try {
            setConfirmLoading(true);

            const resultAction = await dispatch(deleteRole(id))
            if (deleteRole.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || "Deleted")
                setAlertType('success')
                setReload(!reload)
                setOpen(false);
                setConfirmLoading(false);
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            } else {
                setAlertMessage(resultAction?.payload || "Error deleting role")
                setAlertType('error')
                setReload(!reload)
                setOpen(false);
                setConfirmLoading(false);
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            }
        } catch (error) {
            setConfirmLoading(false);
            setAlertMessage("Error deleting role")
            setAlertType('error')
            setOpen(null);
        }
        
    };
    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Roles</h1>
                <Can permission="create_role">
                    <Button type="primary" onClick={() => navigate('/role/add')}>Add Role</Button>
                </Can>
            </div>
            {alertMessage && (
                <Alert
                    message={alertMessage}
                    type={alertType}
                    showIcon
                    icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                    closable
                    onClose={() => setAlertMessage('')}
                    style={{
                        marginBottom: 24,
                        borderRadius: '8px',
                    }}
                />
            )}
            <TableComponent
                listData={getRoles}
                columns={columns}
                reload={reload}
                placeholder="Search codes..."
            />
        </div>
    )
}

export default RoleList